
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.796 15.999c0-7.565-6.115-13.72-13.633-13.72-7.515 0-13.632 6.155-13.632 13.72S10.648 29.72 18.163 29.72c7.517 0 13.633-6.155 13.633-13.721zM18.178 32h-.015-17.02-.003c-.625 0-1.134-.51-1.134-1.142 0-.628.509-1.14 1.134-1.14l4.319-.002 4.557-.002c-4.634-2.8-7.751-7.89-7.751-13.715C2.265 7.177 9.397 0 18.163 0S34.06 7.178 34.06 15.999c0 8.818-7.122 15.992-15.882 16.001zm16.966-2.279c.625 0 1.13.51 1.13 1.138 0 .631-.505 1.14-1.13 1.14h-4.521a1.134 1.134 0 01-1.131-1.14c0-.628.505-1.138 1.131-1.138h4.521zM24.867 7.95c.444-.446 1.164-.446 1.608 0s.444 1.171 0 1.618l-6.544 6.595 6.544 6.597a1.15 1.15 0 010 1.618 1.127 1.127 0 01-1.606 0l-6.543-6.596-6.542 6.596a1.13 1.13 0 01-.707.331l-.097.004c-.291 0-.583-.112-.803-.335a1.15 1.15 0 010-1.618l6.543-6.597-6.543-6.595c-.444-.447-.444-1.171 0-1.618s1.164-.446 1.608 0l6.542 6.594z"}})])
          )
        }
      }
    